import { useState } from 'react';
import { Paper, Stack, Title, Text, Group, ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useAuth } from '../../hooks/useAuth';
import { trackEvent, AnalyticsEvent } from '../../utils/analytics';
import { env } from '../../utils/env';
import { EmailSignupForm } from './EmailSignupForm';

const CARD_STORAGE_KEY = 'email_signup_card_dismissed_at';
const POPUP_STORAGE_KEY = 'email_signup_popup_dismissed_at';

export const EmailSignupCard = () => {
  const { user } = useAuth();
  const [isVisible, setIsVisible] = useState(() => {
    if (user) return false;

    const dismissedAt = localStorage.getItem(CARD_STORAGE_KEY);
    if (!dismissedAt) return true;

    const elapsedMs = Date.now() - parseInt(dismissedAt);
    return elapsedMs >= env.EMAIL_SIGNUP_CARD_SHOW_AFTER_MS;
  });

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem(CARD_STORAGE_KEY, Date.now().toString());
    trackEvent(AnalyticsEvent.EMAIL_LIST_SIGNUP_DISMISSED, {});
  };

  const handleSubmit = async () => {
    // Set both components to hide for 7 days on successful signup
    const farFuture = Date.now() - env.EMAIL_SIGNUP_SUCCESS_HIDE_MS;
    localStorage.setItem(CARD_STORAGE_KEY, farFuture.toString());
    localStorage.setItem(POPUP_STORAGE_KEY, farFuture.toString());
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <Paper shadow="sm" p="xs" withBorder>
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start">
          <Stack gap={0}>
            <Group justify="space-between">
              <Title order={3}>Stay Updated!</Title>
              <ActionIcon
                color="gray"
                variant="subtle"
                onClick={handleClose}
                className="plausible-event-name=Email-List-Signup-Dismiss"
              >
                <IconX size={18} />
              </ActionIcon>
            </Group>
            <Text size="sm" c="dimmed">
              Get notified about new listings and exclusive offers.
            </Text>
          </Stack>
        </Group>

        <EmailSignupForm onSubmit={handleSubmit} buttonFullWidth />
      </Stack>
    </Paper>
  );
};
